module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Gc-Hc-Ia-Gd.7e5420ef.png";